// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuTeaserColumn__container","doubleWide":"MenuTeaserColumn__doubleWide","hiddenTitle":"MenuTeaserColumn__hiddenTitle"};